import { assistantClient } from './assistant-client';
import type { ConfirmationDraft } from '../types/assistant.types';

export interface PendingOperation {
  id: number;
  status: string;
  draft: ConfirmationDraft;
  expires_at: string;
  result: Record<string, unknown> | null;
}

export interface AssistantRun {
  id: number;
  request_id: string;
  status: string;
  outcome: {
    text?: string;
    message_id?: string;
    confirmation?: { draft: ConfirmationDraft };
  };
  error: string;
}

export async function recoverConversation(id: number) {
  const [runs, pending] = await Promise.all([
    assistantClient.get<{ results: AssistantRun[] }>(
      `assistant/conversations/${id}/runs/`
    ),
    assistantClient.get<{ results: PendingOperation[] }>(
      'assistant/pending-actions/',
      {
        params: { conversation: id, page_size: 100 },
      }
    ),
  ]);
  return { runs: runs.data.results, pending: pending.data.results };
}

export async function reconcileOperation(id: number) {
  return (
    await assistantClient.post<PendingOperation>(
      `assistant/pending-actions/${id}/reconcile/`
    )
  ).data;
}
